import {ActionButtonsComponent} from './components/action-buttons/action-buttons.component';
import {AlertsInfoComponent} from './components/alerts-info/alerts-info.component';
import {ButtonCircleComponent} from './components/button-circle/button-circle.component';
import {ButtonDefaultComponent} from './components/button-default/button-default.component';
import {CardsComponent} from './components/cards/cards.component';
import {DragFileComponent} from './components/drag-file/drag-file.component';
import {LabelComponent} from './components/label/label.component';
import {ListComponent} from './components/list/list.component';
import {LiListTextComponent} from './components/list/li-list-text/li-list-text.component';
import {LoadingComponent} from './components/loading/loading.component';
import {ModalHandlerComponent} from './components/modal-handler/modal-handler.component';
import {NavTopComponent} from './components/nav-top/nav-top.component';
import {NotResultsComponent} from './components/not-results/not-results.component';
import {PaginationDetailComponent} from './components/pagination-detail/pagination-detail.component';
import {AsideTemplateComponent} from './components/aside-template/aside-template.component';
import {RatingComponent} from './components/rating/rating.component';
import {ChartComponentComponent} from './components/chart-component/chart-component.component';
import {ChartAmchartComponent} from './components/chart-component/chart-amchart/chart-amchart.component';
import {ChartAmchartLineComponent} from './components/chart-component/chart-amchart-line/chart-amchart-line.component';
import {ChartAmchartColumnComponent} from './components/chart-component/chart-amchart-column/chart-amchart-column.component';
import {DragulaListComponent} from './components/dragula-list/dragula-list.component';
import {SearchComponent} from './components/search/search.component';
import {InputTextComponent} from './components/inputs/input-text/input-text.component';
import {InputTextareaComponent} from './components/inputs/input-textarea/input-textarea.component';
import {TableComponent} from './components/table/table.component';
import {InputTableComponent} from './components/table/input-table/input-table.component';
import {InputCheckComponent} from './components/inputs/input-check/input-check.component';
import {InputDateComponent} from './components/inputs/input-date/input-date.component';
import {InputDropdownComponent} from './components/inputs/input-dropdown/input-dropdown.component';
import {BodyTableComponent} from './components/table/body-table/body-table.component';
import {ModalComponent} from './components/modal/modal.component';
import {AnimatedSearchComponent} from './components/animated-search/animated-search.component';
import {BatmanComponent} from './components/batman/batman.component';
import {AnimatedInputComponent} from './components/animated-input/animated-input.component';
import {CardHeaderComponent} from './components/cards/card-header/card-header.component';
import {CardFooterComponent} from './components/cards/card-footer/card-footer.component';
import {CardBodyComponent} from './components/cards/card-body/card-body.component';
import {ModalHeaderComponent} from './components/modal/modal-header/modal-header.component';
import {ModalBodyComponent} from './components/modal/modal-body/modal-body.component';
import {ModalFooterComponent} from './components/modal/modal-footer/modal-footer.component';
import {AsideComponent} from './components/aside/aside.component';
import {LoginComponent} from './view/login/login.component';
import {TermsComponent} from './view/login/terms/terms.component';
import {MainV1Component} from './view/main-v1/main-v1.component';
import {MainV2Component} from './view/main-v2/main-v2.component';
import {SidebarMenuComponent} from './components/sidebar-menu/sidebar-menu.component';
import {InputRadioComponent} from './components/inputs/input-radio/input-radio.component';
import {TabContentDirective, TabDirective, TabsetComponent, TabTitleDirective} from './components/tabs/tabs.component';
import {AccordionComponent, PanelContentDirective, PanelDirective, PanelTitleDirective} from './components/accordion/accordion.component';
import {CommonModule} from '@angular/common';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {SidebarModule} from 'ng-sidebar';
import {AmChartsModule} from '@amcharts/amcharts3-angular';
import {DragulaModule} from 'ng2-dragula';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbModule.forRoot(),
    SidebarModule.forRoot(),
    AmChartsModule,
    DragulaModule,
    ReactiveFormsModule
  ],
  declarations: [
    ActionButtonsComponent,
    AlertsInfoComponent,
    ButtonCircleComponent,
    ButtonDefaultComponent,
    CardsComponent,
    DragFileComponent,
    LabelComponent,
    ListComponent,
    LiListTextComponent,
    LoadingComponent,
    ModalHandlerComponent,
    NavTopComponent,
    NotResultsComponent,
    PaginationDetailComponent,
    SidebarMenuComponent,
    AsideTemplateComponent,
    RatingComponent,
    ChartComponentComponent,
    ChartAmchartComponent,
    ChartAmchartLineComponent,
    ChartAmchartColumnComponent,
    DragulaListComponent,
    SearchComponent,
    InputTextComponent,
    InputTextareaComponent,
    TableComponent,
    InputTableComponent,
    InputCheckComponent,
    InputDateComponent,
    InputDropdownComponent,
    InputRadioComponent,
    BodyTableComponent,
    ModalComponent,
    AnimatedSearchComponent,
    BatmanComponent,
    AnimatedInputComponent,
    CardHeaderComponent,
    CardFooterComponent,
    CardBodyComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    AsideComponent,
    TabTitleDirective,
    TabContentDirective,
    TabDirective,
    TabsetComponent,
    PanelTitleDirective,
    PanelContentDirective,
    PanelDirective,
    AccordionComponent,
    LoadingComponent,
    LoginComponent,
    TermsComponent,
    MainV1Component,
    MainV2Component,
  ],
  exports: [
    ActionButtonsComponent,
    AlertsInfoComponent,
    ButtonCircleComponent,
    ButtonDefaultComponent,
    CardsComponent,
    DragFileComponent,
    LabelComponent,
    ListComponent,
    LiListTextComponent,
    LoadingComponent,
    NavTopComponent,
    NotResultsComponent,
    PaginationDetailComponent,
    SidebarMenuComponent,
    AsideTemplateComponent,
    RatingComponent,
    ChartComponentComponent,
    ChartAmchartComponent,
    ChartAmchartLineComponent,
    ChartAmchartColumnComponent,
    DragulaListComponent,
    SearchComponent,
    InputTextComponent,
    InputTextareaComponent,
    TableComponent,
    InputTableComponent,
    InputCheckComponent,
    InputDateComponent,
    InputDropdownComponent,
    InputRadioComponent,
    BodyTableComponent,
    ModalComponent,
    AnimatedSearchComponent,
    BatmanComponent,
    AnimatedInputComponent,
    CardHeaderComponent,
    CardFooterComponent,
    CardBodyComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    ModalFooterComponent,
    AsideComponent,
    TabTitleDirective,
    TabContentDirective,
    TabDirective,
    TabsetComponent,
    PanelTitleDirective,
    PanelContentDirective,
    PanelDirective,
    AccordionComponent,
    LoadingComponent,
    LoginComponent,
    TermsComponent,
    MainV1Component,
    MainV2Component,
    ModalHandlerComponent

  ],
  entryComponents: [
    ModalHandlerComponent,
    ChartAmchartLineComponent,
    ChartAmchartColumnComponent
  ]
})
export class FrwModule {
}
